module.exports = __webpack_public_path__ + "static/img/JOSE_ANGEL.1b5285a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/JOSE_ANGEL.jpg
// module id = CCLV
// module chunks = 1